export default __webpack_public_path__ + "static/media/ycombinator.b0aaac83.svg";